import { DocumentTypeEnum, GenderEnum, Identification } from '~/layers/forms/models'

import type { Person } from '.'

export interface Beneficiary extends Person {
  relationship: string | null
  percentage: number | null
}

function load(model?: Partial<Beneficiary> | null): Beneficiary {
  return {
    identification: model?.identification ?? Identification.load(),
    name: model?.name ?? null,
    firstLastName: model?.firstLastName ?? null,
    secondLastName: model?.secondLastName ?? null,
    birthDate: model?.birthDate ?? null,
    gender: model?.gender ?? null,
    relationship: model?.relationship ?? null,
    percentage: model?.percentage ?? null,
  }
}

export const RelationshipTypes = {
  SPOUSE: 'ESPOSO(A)',
  CHILD: 'HIJO(A)',
  PARENT: 'PADRE / MADRE',
  SIBLINGS: 'HERMANO(A)',
  GRANDPARENT: 'ABUELO(A)',
  GRANDCHILD: 'NIETO(A)',
  UNCLE_AUNT: 'TÍO(A)',
  COUSIN: 'PRIMO(A)',
  NEPHEW_NIECE: 'SOBRINO(A)',
  IN_LAW: 'CUÑADO(A)',
  STEPPARENT: 'PADRASTRO / MADRASTRA',
  STEPCHILD: 'HIJASTRO(A)',
  GODPARENT: 'PADRINO / MADRINA',
  GODCHILD: 'AHIJADO(A)',
  GREAT_GRANDPARENT: 'BISABUELO(A)',
  GREAT_GRANDCHILD: 'BISNIETO(A)',
  GREAT_UNCLE_AUNT: 'TÍO(A) ABUELO(A)',
  GREAT_NEPHEW_NIECE: 'SOBRINO(A) NIETO(A)',
} as const

function getRelationshipTypeList() {
  return Object.values(RelationshipTypes)
}

const map = {
  toBeneficiarioViewModelModel(model: Beneficiary): SiteApiSchema<'BeneficiarioViewModel'> {
    return {
      tipoId: model.identification.type
        ? DocumentTypeEnum[model.identification.type].code
        : undefined,
      identificacion: model.identification.number?.replace('-', '').trim(),
      nombres: model.name,
      apellido1: model.firstLastName,
      apellido2: model.secondLastName,
      sexo: model.gender ? GenderEnum[model.gender].label[0] : undefined,
      parentesco: model.relationship,
      fechaNacimiento: model?.birthDate ? model.birthDate.toJSON() : undefined,
      porcentaje: model.percentage ? model.percentage.toString() : undefined,
    }
  },
}

export const Beneficiary = {
  load,
  getRelationshipTypeList,
  map,
}
